<template>
    <el-row :gutter="30"  class="mw-100 manage-story" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentStoryData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addStoryRef"
                            :model="currentStoryData"
                            :rules="currentStoryDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="manageStory('addStoryRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="4" :xs="24">
                                    <el-form-item  label="story order"  >
                                        <el-input type="text" v-model="currentStoryData.seq"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :xs="24">
                                    <el-form-item  label="story image" prop="imageBase64">
                                        <el-image 
                                            style="width: 150px; height: 150px;margin-right:20px" 
                                            :src="isAddStory ? currentStoryData.imageURL :  $getImage(currentStoryData.imageURL) || ''" 
                                            fit="cover"
                                            :zoom-rate="1.2"
                                            :preview-src-list="[isAddStory ? currentStoryData.imageURL : $getImage(currentStoryData.imageURL)]"
                                            :preview-teleported="true"
                                        >
                                            <template #error>
                                                <div class="image-slot">
                                                    <font-awesome-icon :icon="['fas', 'image']" />
                                                </div>
                                            </template>
                                        </el-image>
                                        <el-upload
                                            ref="imageBase64"
                                            action="#"
                                            :auto-upload="false"
                                            :on-change="onUploadImage"
                                            :disabled="fileUploaded"
                                            :on-remove="handleRemoveImage"
                                            accept="image/png, image/jpeg,image/gif"
                                            class="font-24 d-flex align-center flex-1"
                                        >
                                            <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                
                                
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentStoryData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="textarea" v-model="currentStoryData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddStory:true,
            currentStory:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentStoryData:{},
            currentStoryDataRules:{
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedStory(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.stories.currentStory || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedStory.id) {
            this.isAddStory = false;
            this.currentStoryData = JSON.parse(JSON.stringify(this.cachedStory))
            this.currentStoryData.translates = this.$filterPublishedTranslates(this.currentStoryData.translates)
        }else{
            this.$router.push({
                name:'manage-story',
            })
            this.currentStoryDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddStory = true;
            this.currentStoryData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageStory(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addStoryRef'].length){
                            this.manageStoryAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageStoryAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddStory ? 'addStory':'editStory',this.currentStoryData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllStories');
                this.$router.push({
                    name:'stories-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentStoryData.imageBase64 = evt.target.result;
                }); 
                this.currentStoryData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentStoryData.imageURL = this.isAddStory ? '' : this.cachedStory.imageURL
        }, 
    }
}
</script>
<style lang="scss">
    .manage-story {
        .ck-editor {
            width:100%;
        }
    }
</style>